export default "__VITE_ASSET__CzI_A18S__"